<template>
  <div class="slider-item-bottom-container">
    <div class="jackpot-holder" :class="['jackpot-holder-' + gameId]">
      <span v-if="(section && !['tmu', 'tcp', 'tmw', 'tml'].includes(section)) || !section" class="jackpot-box hidden">
        <span class="jackpot-currency"></span>
        <span class="jackpot-amount"></span>
      </span>
    </div>
    <div v-if="!gameInfoLoading" @click="showHideInfo()" :class="[{'game-info': !show}, {'game-info-active': show}]"></div>
    <circle-loader v-if="gameInfoLoading" class="game-info-loader"></circle-loader>
    <div class="text-xs-center">
      <v-menu
        v-if="show"
        v-model="show"
        :close-on-content-click="false"
        :nudge-width="247"
        :nudge-bottom="25"
        :left="true"
        :offset-overflow="true"
        offset-y
        content-class="game-info-details"
      >
        <template v-slot:activator="{ on }">
          <div ref="triggerClick"></div>
        </template>

        <div class="game-info-content">
          <div class="game-info-name" v-if="gameInfoData.name">{{ gameInfoData.name }}</div>
          <div class="game-info-body">
            <div class="game-info-container">
              <div class="game-info-group">
                <div class="game-info-group-item">
                  <template v-if="gameInfoData.reels">
                    <div class="game-info-group-item-name">{{ $t('Casino.InfoData.Reels') }}</div>
                    <div class="game-info-group-item-value"></div>
                  </template>
                </div>
                <div class="game-info-group-item">
                  <template v-if="gameInfoData.lines || gameInfoData.ways">
                    <div class="game-info-group-item-name">{{ gameInfoData.ways ? $t('Casino.InfoData.Ways') : $t('Casino.InfoData.Lines') }}</div>
                    <div class="game-info-group-item-value">{{ gameInfoData.lines }}</div>
                  </template>
                </div>
                <div class="game-info-group-item">
                  <template v-if="gameInfoData.rtp">
                    <div class="game-info-group-item-name">{{ $t('Casino.InfoData.RTP') }}</div>
                    <div class="game-info-group-item-value">{{ gameInfoData.rtp }}</div>
                  </template>
                </div>
              </div>
              <div class="game-info-group">
                <template v-if="gameInfoData.volatility">
                  <div class="game-info-group-item volatility-container">
                    <div class="volatility-scale"></div>
                    <div class="volatility-pointer"></div>
                    <div class="volatility-label-box">
                      <div class="volatility-label-tile">{{ $t('Casino.InfoData.Volatility') }}</div>
                      <div></div>
                    </div>
                  </div>
                </template>
                <div class="game-info-group-item game-launcher">
                  <v-btn class="play_btn" :disabled="isLoggedIn && !isGeolocated" @click="startCasinoLauncher(gameId)">{{ isLoggedIn ? $t('Casino.InfoData.Play') : $t('Casino.InfoData.LoginAndPlay') }}</v-btn>
                </div>
              </div>
              <div v-if="gameInfoData.volatilityName" class="volatility-label-value">
                <div class="vol-label-val">{{ gameInfoData.volatilityName }}</div>
                <div class="vol-label-val"></div>
              </div>
              <div class="game-info-group features">
                <template v-if="gameInfoData.features" v-for="(feature) in gameInfoData.features">
                  <span class="feature-item">{{ feature }}</span>
                </template>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <div>
            <a @click.stop="toggleRTPstore()">{{ $t('Casino.RTP.Info') }}</a>
          </div>
        </div>
      </v-menu>
    </div>
  </div>
</template>
<script>
import CircleLoader from '@/components/common/CircleLoader'
import Casino from '@/components/mixins/Casino'
import GeoLocation from '@/components/mixins/GeoLocation'
import Account from '@/components/mixins/Account'
import store from '@/store'

export default {
  name: 'casinoJackpotAndGameInfoSection',
  props: ['gameId', 'section'],
  mixins: [
    Casino,
    Account,
    GeoLocation
  ],
  components: {
    CircleLoader
  },
  data () {
    return {
      show: false,
      gameInfoData: false,
      gameInfoLoading: false,
      jackpotData: '',
      startJackpotAmount: false,
      currentJackpotAmount: false,
      finalJackpotAmount: false,
      rtpPopup: false
    }
  },
  computed: {
    allJackpots () {
      return store.getters['gap/getAllJackpotsData']
    }
  },
  methods: {
    showHideInfo () {
      if (!this.show) {
        this.gameInfoLoading = true
        this.getGameInfo(this.gameId).then(response => {
          this.gameInfoData = response.data
          this.show = true
          this.gameInfoLoading = false
          if (response.data.volatility) this.setVolatility(response.data.volatility)
          let event = {
            'event': 'casino_game_info',
            'gaEventCategory': response.data.type || 'N/A',
            'gaEventAction': 'casino_game_info success',
            'gaEventLabel': response.data.name || 'N/A',
            'gaGameId': this.gameId || 'N/A',
            'accountId': localStorage.customer || 'N/A'
          }
          let xtremeObj = {
            'param1': 'event',
            'param2': 'casino_game_info',
            'param3': response.data
          }
          this.updateAnalytics(event, xtremeObj)
        }).catch(error => {
          console.log('CASINO GET game info error', error)
          this.gameInfoLoading = false
        })
      }
    },
    setVolatility (volatilityNumber) {
      setTimeout(() => {
        let volatilityPercentage = volatilityNumber / 10 * 180
        let pointer = document.getElementsByClassName('volatility-pointer')[0]
        let translate = 2.2
        if (volatilityPercentage > 30 && volatilityPercentage < 60) {
          translate = 3.2
        } else if (volatilityPercentage > 60 && volatilityPercentage < 120) {
          translate = 3.2
        } else if (volatilityPercentage > 120 && volatilityPercentage < 160) {
          translate = 1.2
        }
        if (pointer) pointer.style.transform = `rotate(${volatilityPercentage}deg) translate(${translate}px, -7px)`
      }, 0)
    },
    toggleRTPstore () {
      store.commit('gap/setRTPstore', {gameId: this.gameId, param: 'open'})
    }
  },
  mounted () {
    setTimeout(() => {
      if (!this.section || (this.section && !['tmu', 'tcp', 'tmw', 'tml'].includes(this.section))) {
        this.setJackpotIfAvailableForThisGame(this.gameId, 'game')
      }
    }, 0)
  },
  beforeDestroy () {
    this.onComponentDestroyedCheckIsJackpotVisibleAnywhere(this.gameId)
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/css/config'
@import '~@/css/mixins'

.slider-item-bottom-container
  position relative
  top -28px
  display flex
  .jackpot-holder
    flex-grow: 1
    text-align: center
    .jackpot-box
      position relative
      border-radius: 13px
      right -15px
      background-color: rgba(0, 0, 0, 0.8)
      opacity: 1
      padding: 3px 6px
      color: #fff
      z-index 1
      font-weight bold
      &.hidden
        display: none
      &:before
        content ''
        position absolute
        inset -2px
        background linear-gradient(45deg, #d2943a, #f7d399, #f0b85f)
        border-radius 13px
        z-index -1
      .jackpot-currency
        color #eda541
  .game-info
    height: 25px
    width: 21px
    background-image var(--casino-game-info-icon)
    margin 0 3px 3px 0
  .game-info-active
    height: 21px
    width: 21px
    background-image url("~@/assets/images/icons/icon-close-white.svg")
  .game-info-loader
    height: 22px
    width: 21px
    position: relative
    top: -10px
    border-width: 3px

.game-info-details
  padding: 16px
  color: initial
  border-radius: 10px
  border: 1px solid #000000
  opacity: 0.95
  background var(--casino-game-info-bgr)
  color var(--casino-game-info-color)
  .game-info-content
    .game-info-name
      font-size: 16px
      font-family: 'Roboto Condensed Bold'
      margin-bottom: 15px
    .game-info-body
      .game-info-container
        .game-info-group
          display: flex
          margin-bottom: 15px
          &.features
            display: block
          .game-info-group-item
            flex: 1
          .game-launcher
            margin: 0
          .volatility-container
            height: 50px
            overflow: hidden
            padding: 0 1px
            position: relative
            width: 80px
            top: -6px
            padding-top: 7px
            .volatility-scale
              -webkit-mask-image: radial-gradient(circle at center, transparent 62.75%, black 65%, black 70%, transparent 71.5%)
              background: linear-gradient(to right, #3a648e 0%, #28ffbb 25%, #ffd500 50%, #ff522b 75%, #9c2c2c 100%) border-box
              height: 80px
              width: 80px
            .volatility-pointer
              box-sizing: border-box
              background: white
              border: 0.5px solid black
              border-radius: 4px
              bottom: -4px
              content: ''
              height: 10px
              left: 0
              position: absolute
              transform-origin: 42.2px 0
              width: 10px
            .volatility-label-box
              color: inherit
              position: relative
              top: -60px
              left: 17px
              font-size: 12px
        .volatility-label-value
          position: relative
          top: -25px
          ffont-family 'Roboto Condensed Bold'
          display: flex
          text-align: center
          font-size: 16px
          .vol-label-val
            flex: 1
            padding-right: 25px
        .feature-item
          border: 2px solid #1A9DDB
          padding: 5px 10px
          border-radius: 50px
          display: table
          margin-bottom: 5px

.play_btn
  background var(--casino-play-game-btn-bgr)
  color var(--casino-play-game-btn-color)
  border var(--casino-play-game-btn-border)
  border-radius 6px
  font-family 'Roboto Condensed Bold'
  font-size 16px
</style>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoJackpotAndGameInfoSection.vue